<template>
  <!--      手信souvenir -->
  <div id="ad-block-6" class="ad-block-2">
    <div class="justify-align">
      <div class="title-box" @click="goSouvenirList" style="display: inline-block;margin-right: 2vw;">
        <div class="title-txt">{{param.title}}</div>
        <div class="title-box-line"></div>
      </div>
      <div @click="goSouvenirList" class="right-box" style="color: #A1A0A0;font-size: 3.2vw;">
        更多>
      </div>
    </div>
    <div class="yuan-box" id="gift-goods">
      <div class="item-yuan" v-for="(good,i) in param.data" :key="i" @click="goDesGoodGift(good.id)">
        <img :src="good.image" alt="" />
        <div class="price-box">
          <div class="price-df">￥{{good.price}}</div>
          <div class="price-original">￥{{good.market_price}}</div>
        </div>
      </div>
    </div>
  </div>
  <!--      手信end-->
</template>

<script>
export default {
  name: "giftGoods",
  props:['param'],
  methods: {
    goSouvenirList(){
      var type= 'gift'
      this.$router.push({name:'activityTheme',params: {type:type}});
    },
    goDesGoodGift(id){
      this.$router.push({path:'/goodDetails',query:{id:id}})
    },
  }
}
</script>

<style lang="scss" scoped>
.title-box{
  display: inline-block;font-size: 32px;color: #1D1D1D;font-weight: bold;margin-left: 24px;
  position: relative;padding: 22px 0;
  .title-txt{
    width: 143px;text-align: center;
  }
  .title-box-line{
    width: 143px;
    height: 15px;
    background: #FEDC32;
    border-radius: 8px;margin-top: -15px;
  }
}
#gift-goods{
  display: flex;
  flex-wrap: nowrap;
  margin-top: 10px;
  width: 100%;
  overflow: hidden;overflow-x: auto;
  .item-yuan{
    font-size: 24px;color: #AEAEAE;display: inline-block;margin-right: 20px; width: 150px;
    img{
      width: 150px;
      height: 124px;display: block;margin: 0 auto;
    }
    .price-box{
      text-align: center;padding-bottom: 20px;padding-top: 20px;
    }
    .price-df{
      font-weight: bold;
      color: #F23926;
      line-height: 28px;font-size: 30px;
    }
    .price-original{
      text-decoration:line-through;
    }
  }
}
</style>
